import { PropsWithChildren } from "react";
import React from "react";
import TabPanel from "atoms/tabs/tab-panel";

const CSS_BASE_CLASS = "c-dashboard-publications-tab-panel";

interface DashboardPublicationsTabPanelProps extends PropsWithChildren {}

const DashboardPublicationsTabPanel = (
    props: DashboardPublicationsTabPanelProps
) => {
    const { children } = props;
    return <TabPanel cssClassName={CSS_BASE_CLASS}>{children}</TabPanel>;
};

export default DashboardPublicationsTabPanel;
